import { useState, useEffect } from 'react'
import Request from '../../Request/Request';
import Store from '../../Store/Store';

export default function Buttons( props ) {

	const [ delState, setDelState ] = useState( 0 )

	const data = props.data
	const original = props.original

	function save( e ) {
		Object.entries( data ).forEach( ( [ key, value ] ) => { 
	    	if ( original[ key ] === data[ key ] ) delete data[ key ]
	    } )
		props.immutables.forEach( key => delete data[ key ] )
		if ( Object.keys( data ).length === 0 ) {
			props.setRowId( false )
		} else if ( props.rowId === true ) {
		    Request.post( 'insert/' + props.table, data,  
				result => props.setRowId( false ),
				error => console.error( error )
		    )
		} else { 
			data.id = props.rowId 
		    Request.post( 'update/' + props.table, data,  
				result => props.setRowId( false ),
				error => console.error( error )
		    )
		} 
	}

	function cancel( e ) {
		props.setRowId( false )
	}

	function del( e ) {

		// update cache to make delete appear immediate
		const oldRows = Store.get( 'rows-' + props.table )
		if ( oldRows ) {
			const index = oldRows.findIndex( row => row.id === props.rowId )
			if ( index >= 0 ) {
				const newRows = oldRows.toSpliced( index, 1 )
				Store.set( 'rows-' + props.table, newRows )
			}
		}
	    Request.delete( 'row/' + props.table, { id: props.rowId },  
			result => props.setRowId( false ),
			error => console.error( error )
	    )

	}

	function Button( props ) {
		return (
			<button 
				className={ 'button' + ( props.className ? ( ' ' + props.className ) : '' ) } 
				style={{ 
					margin:'0 5px 0 5px', maxHeight:44.57, 
					...props.style 
				}}
				onClick={ props.onClick }
			>
				{ props.icon 
				  ? <div style={{ display:'flex' }} >
				    	<div className="material-symbols-outlined" 
				    		style={{ fontWeight:400, flexGrow:1, color:'#fff', fontSize:20, transform:'translateX(-5px)' }} 
				  		>
								{ props.icon }
						</div>
						<div>{ props.label }</div>
					</div>
				  : <div>{ props.label }</div>
				}
			</button>
		)
	}


	return <div style={{ margin:0, padding:'10px 5px 10px 5px', display:'flex' }} >

		<div style={{ flexGrow:1 }} >
			<Button label="Save" onClick={ save } />
		</div>
		<div style={{ flexGrow:5000 }} >
			<Button label="Back" onClick={ cancel } icon="arrow_back" 
				//style={{ background:'#1b5e20' }} 
			/>
		</div>
		{ props.rowId !== true 
		  ?	<div style={{ flexGrow:1 }} >
				{ delState === 0 && 
					<Button label="Delete" style={{ width:99.46 }} onClick={ e => setDelState( 1 ) } />
				}
				{ delState === 1 && <>
					<Button className="button-fade-in" label="Delete" onClick={ del } style={{ background:'#ff1744', border:'2px solid #ff1744' }} />
					<Button label="Cancel" style={{ width:99.46 }} onClick={ e => setDelState( 0 ) } />
				</>}
			</div>
		  : <div style={{ flexGrow:50 }} />
		}


	</div>

}